import { keyframes, styled } from '../../../../lib/stitches'
import { Loading } from '../../../core/icons/responsive-icons'

const spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
})

const Spinner = styled(Loading, {
  width: '24px',
  height: '24px',
  strokeWidth: '1.5px',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  animation: `${spin} 2s linear infinite`
})

export default Spinner
